import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import type {MutableRefObject} from 'react'
import type {Artifact} from '../types'
import {ArtifactListItem} from './ArtifactListItem'

interface ArtifactsListProps {
  org: string
  artifacts: Artifact[]
  totalCount: number
  isV2: boolean
  listRef?: MutableRefObject<HTMLUListElement | undefined>
}

export function ArtifactsList(props: ArtifactsListProps) {
  const {org, artifacts, totalCount, isV2, listRef} = props

  const formatNumber = (num: number): string => {
    return num.toLocaleString()
  }
  const listTitle = `${formatNumber(totalCount)} ${totalCount === 1 ? 'artifact' : 'artifacts'}`

  return (
    <ListView
      variant="default"
      title="Artifacts List"
      titleHeaderTag="h3"
      className="border rounded"
      metadata={<ListViewMetadata title={listTitle} />}
      listRef={listRef}
    >
      {artifacts.map(artifact => (
        <ArtifactListItem key={`artifact-${artifact.artifact_metadata_id}`} artifact={artifact} org={org} isV2={isV2} />
      ))}
      {isV2 && artifacts.length === 0 && (
        <div className="blankslate" role="region" aria-label="No results" aria-live="polite" aria-atomic="true">
          <h3 className="blankslate-heading">No results</h3>
          <p>Try adjusting your search filters.</p>
        </div>
      )}
    </ListView>
  )
}
